import { useLazyCheckPermission } from '@xinchuantw/auth-react';
import { useEffect, useState } from 'react';

import { menuConfig } from '../../../../constants/sidebarMenu';

type MenuGroupItems = typeof menuConfig;
type MenuGroup = MenuGroupItems[number];

const useMenuPermissions = () => {
  const { checkPermission, isLoading } = useLazyCheckPermission();
  const [filteredGroups, setFilteredGroups] = useState<MenuGroupItems>([]);
  const [isCheckingPermissions, setIsCheckingPermissions] = useState(true);

  useEffect(() => {
    const filterMenuGroups = async () => {
      setIsCheckingPermissions(true);

      const allPermissions = new Set<string>();
      menuConfig.forEach((group) => {
        group.items.forEach((item) => {
          item.requiredPermissions?.forEach((permission) => allPermissions.add(permission));
        });
      });

      const permissionResults = await checkPermission(Array.from(allPermissions));

      const filtered = menuConfig.map((group) => {
        const visibleItems = group.items.filter((item) => {
          // No `requiredPermissions` means always visible (no page-level gate).
          if (!item.requiredPermissions || item.requiredPermissions.length === 0) return true;
          return item.requiredPermissions.every((permission) => permissionResults[permission] === true);
        });

        return visibleItems.length > 0 ? { ...group, items: visibleItems } : null;
      });

      const validGroups = filtered.filter((group): group is MenuGroup => group !== null);
      setFilteredGroups(validGroups);
      setIsCheckingPermissions(false);
    };

    filterMenuGroups();
  }, [checkPermission]);

  return {
    filteredGroups,
    isCheckingPermissions: isCheckingPermissions || isLoading,
  };
};

export default useMenuPermissions;